import React from "react";
import {
  LazyLoadImage,
  trackWindowScroll,
} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyLoad = ({
  image,
  key,
  alt,
  scrollPosition,
  style,
  imageClassName,
  imageWrapperClassName,
  onClickFunction,
  title,
}) => {
  return (
    <LazyLoadImage
      key={key}
      style={style}
      onClick={onClickFunction}
      alt={alt}
      effect="blur"
      scrollPosition={scrollPosition}
      src={image}
      className={imageClassName}
      wrapperClassName={imageWrapperClassName}
      title={title}
    />
  );
};

export default trackWindowScroll(LazyLoad);
